module.exports = __webpack_public_path__ + "img/34.c7c18629.jpg";